import React from "react";

import AppBar from '@mui/material/AppBar';
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import "./XSifterAppHeader.css"

const XSifterLogo = require('./xsifter_logo.png');

class XSifterExternalHeader extends React.Component {
 
    render() {
        return (
            <AppBar position="static" color="default" className="xsifter-appbar">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}><img src={XSifterLogo} alt="XSifter Logo" /></Typography>
                    </Toolbar>
                </Container>
            </AppBar>
        )
    }
}

export default XSifterExternalHeader;
